/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RuntimeRoundInfo
 */
export interface RuntimeRoundInfo {
    /**
     * 
     * @type {number}
     * @memberof RuntimeRoundInfo
     */
    version: number;
    /**
     * 
     * @type {string}
     * @memberof RuntimeRoundInfo
     */
    runtimeId: string;
    /**
     * 
     * @type {string}
     * @memberof RuntimeRoundInfo
     */
    runtimeName: string;
    /**
     * 
     * @type {number}
     * @memberof RuntimeRoundInfo
     */
    round: number;
    /**
     * 
     * @type {number}
     * @memberof RuntimeRoundInfo
     */
    timestamp: number;
    /**
     * 
     * @type {number}
     * @memberof RuntimeRoundInfo
     */
    header_type: number;
    /**
     * 
     * @type {string}
     * @memberof RuntimeRoundInfo
     */
    previous_hash: string;
    /**
     * 
     * @type {string}
     * @memberof RuntimeRoundInfo
     */
    io_root: string;
    /**
     * 
     * @type {string}
     * @memberof RuntimeRoundInfo
     */
    state_root: string;
    /**
     * 
     * @type {string}
     * @memberof RuntimeRoundInfo
     */
    messages_hash: string;
    /**
     * 
     * @type {boolean}
     * @memberof RuntimeRoundInfo
     */
    next: boolean;
}

export function RuntimeRoundInfoFromJSON(json: any): RuntimeRoundInfo {
    return RuntimeRoundInfoFromJSONTyped(json, false);
}

export function RuntimeRoundInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuntimeRoundInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'version': json['version'],
        'runtimeId': json['runtimeId'],
        'runtimeName': json['runtimeName'],
        'round': json['round'],
        'timestamp': json['timestamp'],
        'header_type': json['header_type'],
        'previous_hash': json['previous_hash'],
        'io_root': json['io_root'],
        'state_root': json['state_root'],
        'messages_hash': json['messages_hash'],
        'next': json['next'],
    };
}

export function RuntimeRoundInfoToJSON(value?: RuntimeRoundInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'version': value.version,
        'runtimeId': value.runtimeId,
        'runtimeName': value.runtimeName,
        'round': value.round,
        'timestamp': value.timestamp,
        'header_type': value.header_type,
        'previous_hash': value.previous_hash,
        'io_root': value.io_root,
        'state_root': value.state_root,
        'messages_hash': value.messages_hash,
        'next': value.next,
    };
}


